// src/components/Contact.js

import React from "react";
import { motion } from "framer-motion";
import { Phone, Mail, Clock, Instagram, Facebook, Linkedin } from "lucide-react";
import "../styles/Contact.css";

import logoCompleto from "../imagenes/logo.png"; 

const Contact = () => {
  return (
    <motion.div 
      className="contact-page-background"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="contact-layout-grid">
        <motion.div 
          className="contact-info-card"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="contact-info-header">
            <img src={logoCompleto} alt="Logo de Clínica Ciudad San Rafael" className="contact-logo" />
            <p className="contact-tagline">Tu bienestar, nuestra vocación.</p>
          </div>

          <div className="contact-info-body">
            <div className="info-section">
              <h4>Canales de Atención</h4>
              <a href="tel:+5492604421161" className="info-item">
                <Phone />
                <span>0260 442-1161</span>
              </a>
              <a href="mailto:turnos@clinicaciudad.com" className="info-item">
                <Mail />
                <span>info@clinicaciudad.com.ar</span>
              </a>
            </div>

            
          </div>
          
          <div className="contact-socials-footer">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram /></a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><Linkedin /></a>
          </div>
        </motion.div>

        {/* === Panel Derecho: Mapa === */}
        <motion.div 
          className="contact-map-container"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
        >
           <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3294.12353723528!2d-68.3382260242706!3d-34.60099587286626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x967907fe34555555%3A0x82f23a85533ea439!2sAv.%20del%20Libertador%20254%2C%20M5600%20San%20Rafael%2C%20Mendoza!5e0!3m2!1ses-419!2sar!4v1726943187233!5m2!1ses-419!2sar"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación de Clínica Ciudad San Rafael"
          ></iframe>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Contact;